import AppointmentsServicesList from "../AppointmentsServises/AppointmentsServicesList";
import AppointmentsInfoSection from "../AppointmentsInfoSection/AppointmentsInfoSection";

import { ISearchDrawerProps } from "@/shared/interfaces/ui";

import "./AppointmentsMainLeftPart.scss";

export default function AppointmentsMainLeftPart({
    toggleDrawer,
}: ISearchDrawerProps) {
    return (
        <section className='appointment_left_part appointment_part'>
            <AppointmentsInfoSection toggleDrawer={toggleDrawer} />
            <AppointmentsServicesList />
        </section>
    );
}
